import { Button, ButtonGroup } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

export const SplitButtonToggle = <T extends string>({
  className,
  selectedItem,
  items,
  onToggle,
}: {
  className?: string;
  items: { value: T; label: string }[] | T[];
  selectedItem: T;
  onToggle: (toggledItem: T) => void;
}) => {
  return (
    <ButtonGroup isAttached className={classnames('flex', className)}>
      {items.map((item) => {
        const value = typeof item === 'string' ? item : item.value;
        return (
          <Button
            key={value}
            size="sm"
            variant="secondary"
            onClick={() => onToggle(value)}
            // The button adds `data-active` when it is selected. For some reason
            // the `data-active:` variant for tailwind doesn't seem to work so we need to
            // use a custom variant to add this modifier to properly style this button.
            className="flex-1 capitalize [&[data-active]]:bg-btn-primary [&[data-active]]:text-white hover:[&[data-active]]:bg-btn-primary-hover"
            isActive={value === selectedItem}
          >
            {typeof item === 'string' ? item : item.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};
